import { DropdownSeparator } from "@opensea/ui-kit"
import { ContentCopy, Logout, Person, SwapHoriz } from "@opensea/ui-kit/icons"
import { useState } from "react"
import { useTranslations } from "use-intl"
import { useAccount, useDisconnect } from "../../../../../polychain/hooks"
import { FlowActions } from "../../../../../stores/flowStore"
import type { Address } from "../../../../../types"
import {
  ProfileDropdownItem,
  ProfileDropdownItemAvatar,
  ProfileDropdownItemContent,
  ProfileDropdownItemTitle,
} from "./ProfileDropdownItem"
import { SwitchWalletContent } from "./SwitchWalletContent"

type ProfileDropdownContentProps = {
  address: Address
}

export function ProfileDropdownContent({
  address,
}: ProfileDropdownContentProps) {
  const t = useTranslations("wallet.ProfileDropdownContent")
  const { disconnect } = useDisconnect()
  const { address: connectedAddress } = useAccount()
  const isProfileOwner = connectedAddress === address

  const copyAddress = () => {
    navigator.clipboard.writeText(address)
  }

  const handleLogout = async () => {
    await disconnect()
    FlowActions.endFlow()
  }

  const [isSwitchingWallet, setIsSwitchingWallet] = useState(false)
  if (isSwitchingWallet) {
    return <SwitchWalletContent onCancel={() => setIsSwitchingWallet(false)} />
  }

  return (
    <>
      <ProfileDropdownItem onClick={copyAddress}>
        <ProfileDropdownItemAvatar icon={ContentCopy} />
        <ProfileDropdownItemContent>
          <ProfileDropdownItemTitle>
            {t("copyWalletAddress")}
          </ProfileDropdownItemTitle>
        </ProfileDropdownItemContent>
      </ProfileDropdownItem>
      <ProfileDropdownItem href="/profile">
        <ProfileDropdownItemAvatar icon={Person} />
        <ProfileDropdownItemContent>
          <ProfileDropdownItemTitle>
            {t("viewProfile")}
          </ProfileDropdownItemTitle>
        </ProfileDropdownItemContent>
      </ProfileDropdownItem>
      {isProfileOwner && (
        <>
          <DropdownSeparator />
          <ProfileDropdownItem
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              e.preventDefault()
              setIsSwitchingWallet(true)
            }}
          >
            <ProfileDropdownItemAvatar icon={SwapHoriz} />
            <ProfileDropdownItemContent>
              <ProfileDropdownItemTitle>
                {t("switchProfile")}
              </ProfileDropdownItemTitle>
            </ProfileDropdownItemContent>
          </ProfileDropdownItem>
          <ProfileDropdownItem className="text-error-1" onClick={handleLogout}>
            <ProfileDropdownItemAvatar className="text-inherit" icon={Logout} />
            <ProfileDropdownItemContent>
              <ProfileDropdownItemTitle className="text-inherit">
                {t("logout")}
              </ProfileDropdownItemTitle>
            </ProfileDropdownItemContent>
          </ProfileDropdownItem>
        </>
      )}
    </>
  )
}
